import { SELECTION_METHODS, LOWTECH_SELECTION_METHODS } from "./ConstAccessMethodsMock";
import { OTHER_CKBX_VAL } from "./OtherCheckboxUtils";
export const SELECTION_METHOD_BUTTONS = [ 
  {
    value: SELECTION_METHODS.TAP,
    label: 'Tap',
    moreInfo: ''
  },
  {
    value: SELECTION_METHODS.BUTTON,
    label: 'Built-in button',
    moreInfo: ''
  },
  {
    value: SELECTION_METHODS.SWITCH,
    label: 'External switch',
    moreInfo: ''
  },
  {
    value: SELECTION_METHODS.DWELL,
    label: 'Dwell',
    moreInfo: ''
  },
  {
    value: SELECTION_METHODS.SMILE,
    label: 'Smile or other gesture',
    moreInfo: ''
  },
  {
    value: SELECTION_METHODS.BLINK,
    label: 'Eye blink',
    moreInfo: ''
  },
  {
    value: SELECTION_METHODS.SPEECH,
    label: 'Speech',
    moreInfo: ''
  },
  {
    value: SELECTION_METHODS.DIRECT,
    label: 'Direct selection',
    moreInfo: ''
  },
  {
    value: SELECTION_METHODS.SCAN,
    label: 'Scanning',
    moreInfo: '(activate switch when desired option is presented)'
  },
  {
    value: SELECTION_METHODS.MORSE,
    label: 'Morse code',
    moreInfo: '(generate Morse code characters with 1 or 2 switches)'
  },
  {
    value: OTHER_CKBX_VAL,
    label: 'Other',
    moreInfo: '(specify)'
  }
];

export const LOWTECH_SELECTION_METHOD_BUTTONS = [ 
  {
    value: LOWTECH_SELECTION_METHODS.DIRECT,
    label: 'Direct selection',
    moreInfo: '(e.g., touch a picture on a communication board, press a call switch)'
  },
  {
    value: LOWTECH_SELECTION_METHODS.PSCAN,
    label: 'Partner-assisted scanning',
    moreInfo: '(give a signal when partner presents the desired choice)'
  },
  {
    value: OTHER_CKBX_VAL,
    label: 'Other',
    moreInfo: '(specify)'
  }
];

//REGULAR TECH:
//takes an array of selectionMethod values, and returns an array of matching buttons
//if no matching buttons found, it returns an empty array
export function getSelectionMethodBtnsForValues( values){
  let matchingBtns = [];
  let matchingBtn = {};
  if( values){
    for( let i=0; i<values.length; i++){
      matchingBtn = getSelectionMethodBtnForValue(values[i]);
      if(matchingBtn){
        matchingBtns.push(matchingBtn);
      }
    }
    if (!matchingBtns.find(btn => (btn.value === OTHER_CKBX_VAL))){
      let otherBtn = getSelectionMethodBtnForValue(OTHER_CKBX_VAL);
      matchingBtns.push(otherBtn);
    }
  }
  return matchingBtns;
}

export function getSelectionMethodBtnForValue(value){
  const allBtns = SELECTION_METHOD_BUTTONS;
  const matchingBtn = allBtns.find(btn => (value === btn.value));
  return matchingBtn; //returns undefined if no match found
  // if (matchingBtn)
  //   return matchingBtn.label;
  // else
  //   return ""; //no match found
}

//LOW TECH:
//takes an array of selectionMethod values, and returns an array of matching buttons
//if no matching buttons found, it returns an empty array
export function getLowTechSelectionMethodBtnsForValues( values){
  let matchingBtns = [];
  let matchingBtn = {};
  if( values){
    for( let i=0; i<values.length; i++){
      matchingBtn = getLowTechSelectionMethodBtnForValue(values[i]);
      if(matchingBtn){
        matchingBtns.push(matchingBtn);
      }
    }
    if (!matchingBtns.find(btn => (btn.value === OTHER_CKBX_VAL))){
      let otherBtn = getLowTechSelectionMethodBtnForValue(OTHER_CKBX_VAL);
      matchingBtns.push(otherBtn);
    }
  }
  return matchingBtns;
}

export function getLowTechSelectionMethodBtnForValue(value){
  const allBtns = LOWTECH_SELECTION_METHOD_BUTTONS;
  const matchingBtn = allBtns.find(btn => (value === btn.value));
  return matchingBtn; //returns undefined if no match found
}

